
export function getPageVisits() {
	return Number.parseInt(window.localStorage.getItem('page-visits') ?? 0);
}

export function incrementPageVisits() {
	const visits = getPageVisits();
	window.localStorage.setItem('page-visits', visits+1);
}
